import script from "./ServicesScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesScreen.vue?vue&type=script&setup=true&lang=js"

import "./ServicesScreen.vue?vue&type=style&index=0&id=07e9e2f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e9e2f9"]])

export default __exports__